module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("上传到rank目录下")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 3
    }
  }, [_vm._v("文件名")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 21
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.picName),
      callback: function($$v) {
        _vm.picName = $$v
      },
      expression: "picName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onChange
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("上传")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    attrs: {
      "id": "app-4"
    }
  }, [_c('ol', _vm._l((_vm.imgFileList), function(fn) {
    return _c('li', [_vm._v("\n          " + _vm._s(fn.url) + "\n        ")])
  }))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("上传到fhProblem目录下,宽为868px，高不限")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onChange2
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload2
    }
  }, [_vm._v("上传")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    attrs: {
      "id": "app-4"
    }
  }, [_c('ol', _vm._l((_vm.imgFileList2), function(fn) {
    return _c('li', [_vm._v("\n          " + _vm._s(fn.url) + "\n        ")])
  }))])]), _vm._v(" "), _c('h2', [_vm._v("上传到knowledgeImg目录下")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onChange3
    }
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload3
    }
  }, [_vm._v("上传")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    attrs: {
      "id": "app-4"
    }
  }, [_c('ol', _vm._l((_vm.imgFileList3), function(fn) {
    return _c('li', [_vm._v("\n          " + _vm._s(fn.url) + "\n        ")])
  }))])]), _vm._v(" "), _c('el-row'), _vm._v(" "), _c('el-row')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-177aa868"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/upload2Oss.vue
// module id = 632
// module chunks = 1